module.exports = __webpack_public_path__ + "media/images/writer/reservation/sp-bg-5ef228c23e6359e88283c27215e00596.png";